export default __webpack_public_path__ + "static/aaron-b381e85966c450b3929a3192a2b3db13.jpg";